export default __webpack_public_path__ + "static/media/aiSparkles.5e1b74c2.svg";